import { PaymentFacilitatorType as PaymentFacilitatorTypeApi } from '@vendasta/billing';

export enum PaymentFacilitatorType {
  NOT_SET = 'NOT_SET',
  CUSTOM_STRIPE = 'CUSTOM_STRIPE',
  STANDARD_STRIPE = 'STANDARD_STRIPE',
}

export function paymentFacilitatorTypeFromApi(pApi: PaymentFacilitatorTypeApi): PaymentFacilitatorType {
  switch (pApi) {
    case PaymentFacilitatorTypeApi.CUSTOM_STRIPE:
      return PaymentFacilitatorType.CUSTOM_STRIPE;
    case PaymentFacilitatorTypeApi.STANDARD_STRIPE:
      return PaymentFacilitatorType.STANDARD_STRIPE;
    default:
      return PaymentFacilitatorType.NOT_SET;
  }
}

export function paymentFacilitatorTypeToApi(p: PaymentFacilitatorType): PaymentFacilitatorTypeApi {
  switch (p) {
    case PaymentFacilitatorType.CUSTOM_STRIPE:
      return PaymentFacilitatorTypeApi.CUSTOM_STRIPE;
    case PaymentFacilitatorType.STANDARD_STRIPE:
      return PaymentFacilitatorTypeApi.STANDARD_STRIPE;
    default:
      return PaymentFacilitatorTypeApi.UNSPECIFIED;
  }
}
